import { render, staticRenderFns } from "./triggerDialog.vue?vue&type=template&id=5820dac3&scoped=true&"
import script from "./triggerDialog.vue?vue&type=script&lang=js&"
export * from "./triggerDialog.vue?vue&type=script&lang=js&"
import style0 from "./triggerDialog.vue?vue&type=style&index=0&id=5820dac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820dac3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5820dac3')) {
      api.createRecord('5820dac3', component.options)
    } else {
      api.reload('5820dac3', component.options)
    }
    module.hot.accept("./triggerDialog.vue?vue&type=template&id=5820dac3&scoped=true&", function () {
      api.rerender('5820dac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/triggerDialog.vue"
export default component.exports